module.exports = __webpack_public_path__ + "static/media/Laptop.e270981c.svg";